import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { Icon, habitGlyph } from './icons/Icon';
import type { Habit, HabitIconName } from '../types';

/** Habit icon by name — delegates to the BEELYV icon system. */
export function PendingHabitIcon({
  name,
  size = 16
}: {
  name: HabitIconName;
  size?: number;
}) {
  return <Icon name={habitGlyph[name]} size={size} data-id="element-1199" data-mp="1s8gpjzon4gfb" />;
}

/**
 * Compact read-out of what is still open today. It points at the Daily Check
 * instead of becoming a second checklist.
 */
export function PendingHabits({
  habits,
  onOpen
}: {
  habits: Habit[];
  onOpen: () => void;
}) {
  const {
    t
  } = useLocale();
  if (habits.length === 0) return null;
  return <ul className="bee-rail -mx-2 flex gap-1 overflow-x-auto px-2" data-id="element-1200" data-mp="2b69ge3lzozwc">
      {habits.map(habit => {
      return <li key={habit.id} className="shrink-0" data-id="element-1201" data-mp="37o5ps8d9bkll">
            <button type="button" onClick={onOpen} aria-label={`${t(`habit.${habit.id}.title`)} — ${habit.xp} ${t('common.xp')}`} className="flex min-h-[44px] items-center gap-1 rounded-pill border border-sand-line bg-white/70 pl-2 pr-2 transition-colors duration-150 ease-brand hover:border-deep/30" data-id="element-1202" data-mp="37q0ablkm9ap5">
              <span className="text-soft" aria-hidden="true" data-id="element-1203" data-mp="2wacx6afirc1p">
                <Icon name={habitGlyph[habit.icon]} size="sm" data-id="element-1204" data-mp="319h2ur38irna" />
              </span>
              <span className="whitespace-nowrap text-[12.5px] font-medium text-deep" data-id="element-1205" data-mp="2nahg5oza8mtr">
                {t(`habit.${habit.id}.title`)}
              </span>
              <span className="bee-num whitespace-nowrap text-[10.5px] font-bold text-gold-deep" data-id="element-1206" data-mp="2savpdacme2td">
                {habit.xp} {t('common.xp')}
              </span>
            </button>
          </li>;
    })}
    </ul>;
}